import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/chevron_right.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-15f421f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "card-item__logo"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "card-item__content" }
const _hoisted_5 = { class: "bold" }
const _hoisted_6 = {
  key: 0,
  class: "card-item__subtitle"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "card-item__chevron",
  src: _imports_0,
  alt: "Chevron Right"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['card-item', { 'card-item--compact': _ctx.subtitle }]),
    disabled: _ctx.inactive || undefined,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    (_ctx.logoSrc)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.logoSrc,
            alt: _ctx.logoAlt
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.title), 1),
      (_ctx.subtitle)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.subtitle), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.rightText)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(['card-item__right', { bold: _ctx.rightTextBold }])
        }, _toDisplayString(_ctx.rightText), 3))
      : _createCommentVNode("", true),
    _hoisted_7
  ], 10, _hoisted_1))
}